<template>
  <div id="digital-flop">
    <div
      class="digital-flop-item"
      v-for="item in digitalFlopData"
      :key="item.title"
    >
      <div class="digital-flop-title">{{ item.title }}</div>
      <div class="digital-flop">
        <dv-digital-flop
          :config="item.number"
          style="width:150px;height:50px;"
        />
          <div class="unit">{{ item.unit }}</div>
      </div>
    </div>

    <dv-decoration-10 />
  </div>
</template>

<script>
import { getBasicDataApi } from '@/api/school'
export default {
  name: 'DigitalFlop',
  data () {
    return {
      digitalFlopData: [],
      loading: false
    }
  },
  computed: {
    schoolId () {
      return this.$store.getters.schoolId;
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      getBasicDataApi({ schoolId: this.schoolId }).then(res => {
        this.digitalFlopData = [
          {
            title: '注册学员',
            number: {
              number: [res.result.registerCount],
              content: '{nt}',
              textAlign: 'right',
              style: {
                fill: '#4d99fc',
                fontWeight: 'bold'
              }
            },
            unit: '人'
          },
          {
            title: '报名学员',
            number: {
              number: [res.result.studentCount],
              content: '{nt}',
              textAlign: 'right',
              style: {
                fill: '#f46827',
                fontWeight: 'bold'
              }
            },
            unit: '人'
          },
          {
            title: '报名人次',
            number: {
              number: [res.result.signCount],
              content: '{nt}',
              textAlign: 'right',
              style: {
                fill: '#40faee',
                fontWeight: 'bold'
              }
            },
            unit: '次'
          },
          {
            title: '教师数量',
            number: {
              number: [res.result.teacherCount],
              content: '{nt}',
              textAlign: 'right',
              style: {
                fill: '#4d99fc',
                fontWeight: 'bold'
              }
            },
            unit: '人'
          },
          {
            title: '课程数量',
            number: {
              number: [res.result.courseCount],
              content: '{nt}',
              textAlign: 'right',
              style: {
                fill: '#f46827',
                fontWeight: 'bold'
              }
            },
            unit: '个'
          },
          {
            title: '学习次数',
            number: {
              number: [res.result.viewCount],
              content: '{nt}',
              textAlign: 'right',
              style: {
                fill: '#40faee',
                fontWeight: 'bold'
              }
            },
            unit: '次'
          }
        ]
        setTimeout(this.getData, 10000)
      })
    }
  }
}
</script>

<style lang="less">
#digital-flop {
  position: relative;
  height: 15%;
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgba(6, 30, 93, 0.5);

  .dv-decoration-10 {
    position: absolute;
    width: 95%;
    left: 2.5%;
    height: 5px;
    bottom: 0px;
  }

  .digital-flop-item {
    width: 18%;
    height: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-left: 3px solid rgb(6, 30, 93);
    border-right: 3px solid rgb(6, 30, 93);
  }

  .digital-flop-title {
    font-size: 20px;
    margin-bottom: 20px;
  }

  .digital-flop {
    display: flex;
  }

  .unit {
    margin-left: 10px;
    display: flex;
    align-items: flex-end;
    box-sizing: border-box;
    padding-bottom: 13px;
  }
}
</style>
